import { variables } from '@indriver/yrel';

var preset = {
  color: {
    brand: variables['background-brand'],
    onbrand: variables['extensions-text-and-icon-onbrand'],
    error: variables['extensions-background-error'],
    primary: variables['text-and-icon-primary'],
    white: variables['extensions-background-alwayslight'],
    oncolor: variables['text-and-icon-oncolor']
  }
};

export { preset as default };
